import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertCircle } from 'lucide-react';
import { useInspection } from '@/hooks/use-inspection-queries';

export const Route = createFileRoute('/dashboard/inspection/$inspectionId')({
  component: InspectionDetailLayout,
});

function InspectionDetailLayout() {
  const { inspectionId } = Route.useParams();
  const { isLoading, isError, error } = useInspection(inspectionId);

  if (isLoading) {
    return (
      <div className="space-y-6 max-w-2xl mx-auto px-4 py-6">
        <Skeleton className="h-10 w-[300px] rounded-xl" />
        <Skeleton className="h-[600px] w-full rounded-2xl" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex flex-col items-center justify-center py-20 bg-destructive/5 rounded-2xl border border-destructive/10">
        <AlertCircle className="h-12 w-12 text-destructive mb-4" />
        <p className="text-lg font-bold text-destructive">Inspection not found</p>
        <p className="text-sm text-destructive/60 mt-1">
          {error instanceof Error
            ? error.message
            : 'The requested inspection could not be located.'}
        </p>
      </div>
    );
  }

  return <Outlet />;
}
